import React, { useCallback, useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { omit } from 'lodash'
import { SelectInput } from '@demandlocal/components'

const SelfExcludingSelectInput = (props: any): JSX.Element => {
  const { control, column, rowsOptions, i } = props
  const formValues = useWatch()
  const usedColumns = useMemo(() => {
    const rows = omit(formValues, 'source_name')
    return Object.entries(rows)
      .filter(([key, value]) => value)
      .map(([key, value]) => {
        return value.value
      })
  }, [formValues])

  const options = useMemo(() => {
    return rowsOptions.map((parentOption: any) => {
      if (parentOption.is_array) return parentOption
      return {
        ...parentOption,
        options: parentOption?.options?.map((childOption: any) => {
          return {
            ...childOption,
            isDisabled: usedColumns.includes(childOption.value),
          }
        }),
      }
    })
  }, [rowsOptions, usedColumns])

  return (
    <SelectInput
      isClearable={true}
      control={control}
      name={String(column.Header)}
      key={i}
      options={options}
      placeholder={'Do not import'}
      customStyles={{
        control: (base: any, { hasValue }: any) => ({
          ...base,
          border: 'none',
          boxShadow: 'none',
          backgroundColor: hasValue ? 'rgba(55, 231, 94, 0.3)' : 'rgba(0, 56, 255, 0.1)',
        }),
        dropdownIndicator: (base: any, { hasValue }: any) => ({
          ...base,
          marginTop: 4,
          display: hasValue ? 'none' : 'initial',
          padding: '4px 8px',
        }),
        placeholder: (base: any) => ({
          ...base,
          color: '#0932C2',
          fontWeight: '700',
        }),
      }}
    />
  )
}

export default SelfExcludingSelectInput
